/**
 * useModelLabels.ts — دقّة النموذج ومزوّده بلغة الواجهة.
 *
 * نفس قاعدة useLayerLabels: ما كتبه الأدمن صراحةً (نصّ حرّ في قاعدة البيانات) يفوز؛
 * وإلا نبني التسمية من القاموس — الدقّة من resolutionKm والمزوّد من `model.provider.<id>`.
 */
import type { WeatherModel } from '../store/types';
import { useTranslation } from './LanguageContext';

export function useModelLabels() {
    const { t } = useTranslation();
    return {
        /** «22 كم» / «22 km» — أو تسمية الأدمن الحرّة إن وُجدت. */
        modelResolution: (model: WeatherModel): string =>
            model.resolution
            || (model.resolutionKm !== undefined ? t('model.resolution', { km: model.resolutionKm }) : ''),
        /** اسم الجهة المزوّدة — فارغ إن كان النموذج غير معروف ولم يكتب الأدمن شيئاً. */
        modelProvider: (model: WeatherModel): string => {
            if (model.provider) return model.provider;
            const key = `model.provider.${model.id}`;
            const translated = t(key);
            return translated === key ? '' : translated;
        },
    };
}
